module.exports = __webpack_public_path__ + "static/img/ichat_200@2x.48e48b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/ichat_200@2x.png
// module id = 592
// module chunks = 0